import React from "react"
import { Seo } from "../components/seo"
// Layout
import LayoutContent from "../layout/LayoutContent"

// Blocks
import VisualCortexBlock from "../blocks/en/VisualCortexBlock"
import FunctionCortexBlock from "../blocks/en/FunctionCortexBlock"
import HowToUseCortexBlock from "../blocks/en/HowToUseCortexBlock"
import FunctionDetailCortexBlock from "../blocks/en/FunctionDetailCortexBlock"
import FormContactCortexBlock from "../blocks/en/FormContactCortexBlock"
import AwardsBlock from "../blocks/en/AwardsBlock"
const EnglishPage = (props) => {

  return <LayoutContent type={props.location.pathname}>
    <Seo
      title="VisualCortex"
      description="VisualCortex is an image recognition product that provides a deep understanding of the situation in real time, just like human vision."
      url="https://couger.co.jp/visualcortex/" />

    <VisualCortexBlock></VisualCortexBlock>

    <AwardsBlock></AwardsBlock>
    <FunctionCortexBlock></FunctionCortexBlock>
    <HowToUseCortexBlock></HowToUseCortexBlock>
    <FunctionDetailCortexBlock></FunctionDetailCortexBlock>
    <FormContactCortexBlock></FormContactCortexBlock>
  </LayoutContent>

}


export default EnglishPage